<template>
  <div>
    <dashboard-header :text='$t("ui.alarmCaption")'/>
    <v-card
        elevation="0"
        class="card-border-10">

      <d-table
          class="pt-10 px-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :on-delete="isDelete ? deleteItem : null"
          :add="isCreate ? addItem : null"
          :get-items="getItems"
          :custom-total-rows="totalRows"
          :placeholder="placeholder"
      />

    </v-card>
  </div>
</template>

<script>
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";
import {PERMISSIONS} from "../../config/permissions";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      // table
      items: [],
      totalRows: 0,
      optionParams: null,
    };
  },
  mounted() {
    this.onTab()
  },
  computed: {
    placeholder() {
      return i18n.t("ui.placeHolderAlarm")
    },
    isCreate() {
      return this.hasPermission(PERMISSIONS.ALERT_CONTENT_CREATE);
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.ALERT_CONTENT_UPDATE);
    },
    isDelete() {
      return this.hasPermission(PERMISSIONS.ALERT_CONTENT_DELETE);
    },
    fields() {
      const fields = [
        {value: "message", text: i18n.t("ui.alertContent")},
        {value: "numberOfSosCases", text: i18n.t("ui.numberOfSOS"), sortable: false},
      ];
      if (this.isCreate || this.isEdit || this.isDelete) {
        fields.push({value: "actions", sortable: false});
      }
      return fields;
    },
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams)
    },
    async getItems(optionParams) {
      if (!optionParams) return
      this.optionParams = optionParams
      let res = await this.get(API2.SOS_MESSAGE, optionParams)
      if (!res) return
      this.totalRows = res.total
      this.items = res.data.map(value => {
        return {
          data: {...value, idDetail: value.messageId},
          message: value.message,
          name: value.message, // Keep for delete confirmation dialog
          numberOfSosCases: value.numberOfSosCases
        };
      });
    },
    addItem() {
      this.openTab(2)
    },
    editItem(item) {
      this.openTab(2, item)
    },
    onItemTableClick(item) {
      if (!this.checkPermissionOrShowError(PERMISSIONS.ALERT_CONTENT_VIEW)) {
        return;
      }
      this.openTab(1, item)
    },
    async deleteItem(item) {
      // Check if numberOfSosCases > 0
      // if (item.numberOfSosCases > 0) {
      //   this.notifDialog({
      //     title: `${i18n.t("warning.warning")}!`,
      //     content: i18n.t("ui.cannotDeleteAlarmContentWithSosCases"),
      //     textConfirm: i18n.t('ui.confirm'),
      //   });
      //   return;
      // }
      
      let res = await this.delete(API2.SOS_MESSAGE, {path: item.data.messageId})
      if (res) {
        this.showToast("success", i18n.t("base.notification"), i18n.t("base.deleteSuccessful"))
        this.getItems(this.optionParams);
      }
    }
  }
};
</script>

<style></style>
